import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import RothConversionChart from './RothConversionChart';
import { RothConversionTable } from './RothConversionTable';
import { RothConversionProps } from './RothConversionTypes';
import { updateGoalViewState } from '../../FinancialPlanActions';

interface Props {
  clientId: string;
  goalId: string;
  data?: RothConversionProps;
}

export const RothConversionOutput: React.FC<Props> = ({ clientId, goalId, data }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Fixes ➜ https://dev.azure.com/orionadvisor/Orion%20Agile/_workitems/edit/84308
    if (!data) {
      dispatch(updateGoalViewState(goalId, clientId, { selectedSection: 'Overview' }));
    }
  }, [clientId, goalId, data, dispatch]);

  if (!data) {
    return null;
  }

  const { maxTaxBracket } = data;

  return (
    <div>
      <RothConversionChart {...data} key={`${maxTaxBracket?.value}`} />

      <RothConversionTable {...data} />
    </div>
  );
};
